export const state = [
  {
    label: "",
    value: "",
  },
];

export const cardType = {
  0: "身份证",
  1: "护照",
  2: "军人证",
  3: "异常身份证",
  4: "户口本",
  5: "外国人永久居留证",
  6: "警官证",
  7: "出生证",
  8: "其他",
  9: "港澳台回乡证",
  10: "港澳台居民居住证",
  11: "港澳居民来往内地通行证",
  12: "台湾居民来往大陆通行证",
  13: "临时居民身份证",
};

export const statusArr = [
  {
    value: 1,
    label: "待开通",
  },
  {
    value: 2,
    label: "待激活",
  },
  {
    value: 3,
    label: "待使用",
  },
  {
    value: 4,
    label: "待审核",
  },
  {
    value: 5,
    label: "服务中",
  },
  {
    value: 6,
    label: "已完成",
  },
  {
    value: 7,
    label: "已取消",
  },
  {
    value: 8,
    label: "已失效",
  },
  {
    value: 9,
    label: "未激活",
  },
];
export const maritalOption = [
  {
    value: -1,
    label: "未知",
  },
  {
    value: 0,
    label: "未婚",
  },
  {
    value: 1,
    label: "已婚",
  },
  {
    value: 2,
    label: "丧偶",
  },
  {
    value: 3,
    label: "离异",
  },
  {
    value: 4,
    label: "其他",
  },
  {
    value: 5,
    label: "有配偶",
  },
  {
    value: 6,
    label: "无配偶",
  },
];

export const serverStatus = [
  {
    value: 0,
    label: "待计算",
  },
  {
    value: 1,
    label: "未使用",
  },
  {
    value: 2,
    label: "在使用中",
  },
  {
    value: 3,
    label: "未用过期",
  },
  {
    value: 4,
    label: "已用过期",
  },
  {
    value: 5,
    label: "待开通",
  },
  {
    value: 6,
    label: "未开通过期",
  },
  {
    value: 7,
    label: "已开通",
  },

  {
    value: 8,
    label: "已开通过期",
  },
  {
    value: 9,
    label: "待使用",
  },
  {
    value: 10,
    label: "使用中",
  },
  {
    value: 11,
    label: "未用过期",
  },
  {
    value: 12,
    label: "用后过期",
  },
  {
    value: 13,
    label: "赔付完成 ",
  },
  {
    value: 14,
    label: "赔满过期",
  },
];

export const gerderList = [
  {
    label: "不限",
    value: "NONE",
  },
  {
    label: "男性",
    value: "MALE",
  },
  {
    label: "女性",
    value: "FEMALE",
  },
];
export const marryList = [
  {
    label: "不限",
    value: "NONE",
  },
  {
    label: "已婚",
    value: "MARRIED",
  },
  {
    label: "未婚",
    value: "SINGLE",
  },
];
export const dataSourceList = [
  {
    label: "核心",
    value: "00",
  },
  {
    label: "官微",
    value: "01",
  },
];
export const dataSourceList01 = [
  {
    label: "核心系统",
    value: "核心系统",
  },
];
export const policyStatusList = [
  {
    label: "",
    value: 0,
  },
  {
    label: "待开通",
    value: 1,
  },
  {
    label: "待激活",
    value: 2,
  },
  {
    label: "待使用",
    value: 3,
  },
  {
    label: "待审核",
    value: 4,
  },
  {
    label: "服务中",
    value: 5,
  },
  {
    label: "已完成",
    value: 6,
  },
  {
    label: "已取消",
    value: 7,
  },
  {
    label: "已失效",
    value: 8,
  },
  {
    label: "未激活",
    value: 9,
  },
];
export const vipLevelData = {
  1: "普通",
  2: "明珠级",
  3: "白银级",
  4: "黄金级",
  5: "铂金级",
  6: "钻石级",
  7: "黑钻级",
};

export const orderState = [
  {
    value: 1,
    label: "申请中",
  },
  {
    value: 2,
    label: "已接单",
  },
  {
    value: 3,
    label: "预约中",
  },
  {
    value: 4,
    label: "预约成功",
  },
  {
    value: 5,
    label: "已完成",
  },
  {
    value: 6,
    label: "已取消",
  },
  {
    value: 7,
    label: "已出报告",
  },
];
export const serviceOrderState = {
  noHealthy: [
    {
      value: 1,
      label: "申请中",
    },
    {
      value: 2,
      label: "已接单",
    },
    {
      value: 3,
      label: "预约中",
    },
    {
      value: 4,
      label: "预约成功",
    },
    {
      value: 5,
      label: "已取消",
    },
    {
      value: 6,
      label: "已完成",
    },
    {
      value: 7,
      label: "已完成",
    },
  ],
  healthyState: [
    {
      value: 0,
      label: "已预约",
    },
    {
      value: 1,
      label: "已取消",
    },
    {
      value: 2,
      label: "已到检",
    },
    {
      value: 3,
      label: "已出报告",
    },
    {
      value: 4,
      label: "待预约",
    },
  ],
  physicalState: [
    {
      label: "待预约",
      value: 1,
    },
    {
      label: "已预约",
      value: 2,
    },
    {
      label: "已到检",
      value: 3,
    },
    {
      label: "体检逾期",
      value: 4,
    },
    {
      label: "已出报告",
      value: 5,
    },
    {
      label: "已撤销",
      value: 6,
    },
    // {label: '取消预约', value: 7},
    {
      label: "已完成",
      value: 8,
    },
    {
      label: "订单取消",
      value: 9,
    },
    {
      label: "到检取消",
      value: 10,
    },
  ],
};

export const relation = {
  1: "本人",
  2: "夫妻",
  3: "儿女",
  4: "父母",
  5: "岳父",
  6: "岳母",
  7: "公公",
  8: "婆婆",
  9: "其他人",
};

export const operation = [
  {
    value: 1,
    label: "生成订单",
  },
  {
    value: 2,
    label: "预约体检",
  },
  {
    value: 3,
    label: "取消预约",
  },
  {
    value: 4,
    label: "撤销订单",
  },
  {
    value: 5,
    label: "完成体检",
  },
  {
    value: 6,
    label: "体检逾期",
  },
  {
    value: 7,
    label: "报告生成",
  },
  {
    value: 8,
    label: "完成订单",
  },
];

export const exportExcelInfo = {
  // 供应商导入信息
  1: [
    {
      title: "供应商名称",
      key: "supName",
    },
    {
      title: "供应商简称",
      key: "supShortName",
    },
    {
      title: "状态",
      key: "status",
    },
    {
      title: "供应商描述（非必填）",
      key: "providerDesc",
    },
    {
      title: "供应商地址（非必填）",
      key: "providerAddress",
    },
    {
      title: "合同时间",
      key: "contractTime",
    },
    {
      title: "商务联系人",
      key: "contacts",
    },
    {
      title: "联系电话",
      key: "mobile",
    },
    ,
    {
      title: "联系邮箱（非必填）",
      key: "email",
    },
  ],
  // 供应商服务项目导入信息
  2: [
    {
      title: "服务项目名称",
      key: "serviceName",
    },
    {
      title: "服务类别",
      key: "serviceTypeName",
    },
    {
      title: "状态",
      key: "serviceStatus",
    },
    {
      title: "起效日期",
      key: "effectiveTime",
    },
    {
      title: "所属部门",
      key: "branchName",
    },
    {
      title: "第三方编码",
      key: "thirdCode",
    },
    {
      title: "结束日期",
      key: "expireTime",
    },
    {
      title: "单价（非必填）",
      key: "price",
    },
    {
      title: "性别（非必填）",
      key: "genderLimit",
    },
    {
      title: "婚姻状况（非必填）",
      key: "marryLimit",
    },
  ],
  // 供应商网点导入信息
  3: [
    {
      title: "网点名称",
      key: "hospName",
    },
    {
      title: "第三方医院value",
      key: "thirdHospId",
    },
    {
      title: "第三方编码",
      key: "thirdCode",
    },
    {
      title: "省",
      key: "province",
    },
    {
      title: "市",
      key: "city",
    },
    {
      title: "区",
      key: "area",
    },
    {
      title: "网点电话（非必填）",
      key: "hospMobile",
    },
    {
      title: "网点地址",
      key: "hospAddress",
    },
    ,
    {
      title: "状态",
      key: "status",
    },
  ],
};

export const userSourceList = [
  {
    value: 0,
    label: "无",
  },
  {
    value: 1,
    label: "核保体检",
  },
  {
    value: 2,
    label: "ETL同步",
  },
  {
    value: 3,
    label: "官微",
  },
  {
    value: 4,
    label: "健管平台体检报告导入",
  },
];

export const branchIdList = [
  {
    value: 0,
    label: "其他",
  },
  {
    value: 1,
    label: "运营管理",
  },
  {
    value: 2,
    label: "财务管理",
  },
  // {
  //   value: 9,
  //   label: "全部"
  // }
];

export const scoreList = [
  {
    value: 0,
    label: "请选择",
  },
  {
    value: 5,
    label: "很好(5分)",
  },
  {
    value: 4,
    label: "好(4分)",
  },
  {
    value: 3,
    label: "一般(3分)",
  },
  {
    value: 2,
    label: "不好(2分)",
  },
  {
    value: 1,
    label: "很不好(1分)",
  },
];
